import * as React from 'react';
import { graphql } from 'gatsby';
import { BuilderComponent } from '@builder.io/react';
import { Helmet } from 'react-helmet';
import Link from '../components/Link/Link';

const defaultDescription = 'Edit this in your entry for a better SEO';
const defaultTitle = 'Olokoo Q2M';

function BlogTemplate({ data }) {
  const models = data?.allBuilderModels;
  const article = models?.article?.[0]?.content;
  const settings = models?.oneSiteSettings?.content?.data;

  const title = article?.data?.title || settings?.siteName || defaultTitle;
  const description = article?.data?.description || settings?.siteDescription || defaultDescription;
  const url = settings?.siteUrl + article?.data?.url;

  return (
    <>
      <Helmet>
        <title>{ title }</title>
        <meta name="description" content={ description } />
        <link rel="icon" type="image/png" href={ settings?.siteFavicon } sizes="16x16" />
        
        <meta property="og:title" content={ title } />
        <meta property="og:description" content={ description } />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={ url } />
        <meta property="og:image" content={ settings?.siteSocialImage } />

        <meta name="twitter:title" content={ title } />
        <meta name="twitter:description" content={ description } />
        <meta name="twitter:image" content={ settings?.siteSocialImage } />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <BuilderComponent
        renderLink={Link}
        name="article"
        content={article}
      />
    </>
  );
}

export default BlogTemplate;

export const blogQuery = graphql`
  query($path: String!) {
    allBuilderModels {
      article(
        target: { urlPath: $path }
        limit: 1
        options: { cachebust: true }
      ) {
        content
      }
      oneSiteSettings {
        content
      }
    }
  }
`;
